
import { Product } from "@/types/product";

export const dspProducts: Product[] = [
  {
    id: "dtx-44d",
    groupId: "audio-dsps",
    name: "DTX-44D",
    description: "The DTX-44D is a professional 4×4 digital signal processor with built-in Dante™ capabilities. This versatile DSP offers 4 analog microphone/line inputs and 4 analog outputs, plus 8×8 Dante™ digital audio networking, making it ideal for medium-sized installations requiring high-quality audio processing.\n\nProviding exceptional audio quality with studio-grade analog signal conversion at 48kHz, the DTX-44D delivers the advanced processing capabilities needed for professional audio integration. Its comprehensive digital audio toolkit includes acoustic echo cancellation, automixing, comprehensive equalization, dynamics processing, and sophisticated routing options.\n\nSeamlessly integrating with ReAX control systems, the DTX-44D offers both standalone configuration via its web interface and advanced system integration through Aurora Multimedia's control ecosystem. Its sleek 1RU form factor and flexible mounting options make it perfect for commercial installations where space and quality are equally important.",
    features: [
      "4 Analog Inputs (Mic/Line) with Phantom Power",
      "4 Analog Outputs",
      "8×8 Dante™ Digital Audio Networking",
      "48kHz, 24-bit High-Resolution Audio",
      "Acoustic Echo Cancellation (AEC)",
      "ReAX Control System Compatible",
      "Browser-Based Configuration Interface",
      "Pre/Post-Processing Matrices",
      "Multi-Mode Auto Mixer",
      "Extensive EQ, Dynamics and Routing Options",
      "Rack-Mountable 1RU Design"
    ],
    specifications: [
      "Frequency Response: 20Hz to 20kHz, ±0.5dB",
      "Dynamic Range: >110dB",
      "THD+N: <0.005%, +4dBu, 20Hz to 20kHz, 0dB gain",
      "EIN: <-125dBu, 22Hz to 22kHz, 150Ω input",
      "Maximum Input Level: +24dBu",
      "Maximum Output Level: +24dBu",
      "Input Impedance: 8kΩ balanced, >4kΩ unbalanced",
      "Output Impedance: 200Ω balanced, 100Ω unbalanced",
      "Phantom Power: +48V DC",
      "Sampling Rate: 48kHz",
      "A/D-D/A Bit Depth: 24-bit",
      "Power Requirements: 100-240V AC, 50-60Hz",
      "Dimensions: 19\"W x 1.75\"H x 10.5\"D (1RU)",
      "Weight: 8 lbs (3.6 kg)",
      "Operating Temperature: 0°C to 40°C"
    ],
    image: "/lovable-uploads/3ab44682-1c92-4d7a-b99f-7e665e65c005.png",
    images: [
      "/lovable-uploads/3ab44682-1c92-4d7a-b99f-7e665e65c005.png",
      "/lovable-uploads/d3aef7f5-1253-410a-ba5f-cdd0ae4ea80c.png"
    ],
    videoUrl: "https://youtu.be/ZQ6FUxLkFTM?si=NXb_VHAUeBnZtsdj",
    slug: "dtx-44d"
  },
  {
    id: "dtx-88d",
    groupId: "audio-dsps",
    name: "DTX-88D",
    description: "The DTX-88D is an advanced 8×8 digital signal processor with expanded Dante™ networking capabilities. This professional-grade DSP features 8 microphone/line inputs and 8 analog outputs with 16×16 Dante™ digital audio channels, making it ideal for larger installations requiring comprehensive audio processing.\n\nProviding exceptional audio quality with studio-grade preamps and 48kHz/24-bit signal processing, the DTX-88D delivers advanced audio processing capabilities needed for sophisticated commercial sound systems. Its extensive feature set includes acoustic echo cancellation (AEC), automatic mixing, parametric equalization, dynamics processing, and flexible signal routing capabilities.\n\nDesigned for seamless integration with ReAX control systems, the DTX-88D can be configured via its intuitive web interface or through Aurora's control ecosystem. Its full-width 1RU rack-mount design combines robust build quality with comprehensive I/O options, including dual Dante ports, RS-232/485 control, and GPIO integration for external device control.",
    features: [
      "8 Analog Mic/Line Inputs with Phantom Power",
      "8 Analog Line Outputs",
      "16×16 Dante™ Digital Audio Networking",
      "48kHz, 24-bit High-Resolution Audio",
      "Acoustic Echo Cancellation (AEC)",
      "8×8 GPIO Integration",
      "ReAX Control System Compatible",
      "Browser-Based Configuration Interface",
      "Multiple Auto Mixer Modes",
      "Comprehensive EQ and Dynamics Processing",
      "1U Rack-Mountable Design",
      "RS-232 and RS-485 Control Interfaces"
    ],
    specifications: [
      "Analog I/O Channels: 8×8",
      "Dante I/O Channels: 16×16",
      "Frequency Response: 20Hz to 20kHz, ±0.5dB",
      "Input Dynamic Range: 110dB",
      "Output Dynamic Range: 112dB",
      "THD+N: <-94dB @17dBu",
      "Input Impedance: 5.4kΩ",
      "Output Impedance: 600Ω",
      "Maximum Input Level: +18dBu",
      "Analog Noise Floor: -89 dBu (A-weighted)",
      "Channel Isolation: 108 dB (1 kHz)",
      "Phantom Power: +48V/10mA max",
      "Interfaces: 2 Dante Audio, 1 LAN, 1 USB Audio, RS-232, RS-485, 8×8 GPIO",
      "Power: 110-240 VAC at 50-60 Hz",
      "Power Consumption: 25W",
      "Chassis: 1U Rack Mount"
    ],
    image: "/lovable-uploads/4349a886-9d35-433f-9095-828a1646f2d8.png",
    images: [
      "/lovable-uploads/4349a886-9d35-433f-9095-828a1646f2d8.png",
      "/lovable-uploads/f76fd0d3-3919-4460-b064-20679818686e.png",
      "/lovable-uploads/13acc873-36a8-46c7-849c-a1e49eb51c95.png"
    ],
    videoUrl: "https://youtu.be/ZQ6FUxLkFTM?si=NXb_VHAUeBnZtsdj",
    slug: "dtx-88d"
  },
  {
    id: "dtx-1616d",
    groupId: "audio-dsps",
    name: "DTX-1616D",
    description: "The DTX-1616D is a comprehensive 16×16 digital signal processor with extensive Dante™ integration, offering 16×16 channels of digital audio routing. This powerful DSP combines extensive I/O capabilities with professional-grade audio processing, making it perfect for large venues and complex installations.\n\nFeaturing 16 channels of high-quality microphone/line inputs with phantom power and 16 channels of balanced outputs, the DTX-1616D delivers exceptional audio quality with studio-grade preamps and 48kHz/24-bit signal conversion. The comprehensive processing capabilities include acoustic echo cancellation, automixing, parametric EQ, dynamics processing, and sophisticated signal routing.\n\nSeamlessly integrating with ReAX control systems, the DTX-1616D offers both browser-based configuration and integration with Aurora Multimedia's control ecosystem. Its 1RU rack-mount design includes comprehensive connectivity options with dual Dante ports, USB audio, RS-232/485 control interfaces, and 8×8 GPIO for external device integration.",
    features: [
      "16 Analog Mic/Line Inputs with Phantom Power",
      "16 Analog Line Outputs",
      "16×16 Dante™ Digital Audio Networking",
      "48kHz, 24-bit High-Resolution Audio",
      "Acoustic Echo Cancellation (AEC)",
      "8×8 GPIO Integration",
      "ReAX Control System Compatible",
      "Browser-Based Configuration Interface",
      "Multiple Auto Mixer Modes",
      "Comprehensive EQ and Dynamics Processing",
      "1U Rack-Mountable Design",
      "RS-232 and RS-485 Control Interfaces"
    ],
    specifications: [
      "Analog I/O Channels: 16×16",
      "Dante I/O Channels: 16×16",
      "Frequency Response: 20Hz to 20kHz, ±0.5dB",
      "Input Dynamic Range: 110dB",
      "Output Dynamic Range: 112dB",
      "THD+N: <-94dB @17dBu",
      "Input Impedance: 5.4kΩ",
      "Output Impedance: 600Ω",
      "Maximum Input Level: +18dBu",
      "Analog Noise Floor: -89 dBu (A-weighted)",
      "Channel Isolation: 108 dB (1 kHz)",
      "Phantom Power: +48V/10mA max",
      "Interfaces: 2 Dante Audio, 1 LAN, 1 USB Audio, RS-232, RS-485, 8×8 GPIO",
      "Power: 110-240 VAC at 50-60 Hz",
      "Power Consumption: 35W",
      "Chassis: 1U Rack Mount"
    ],
    image: "/lovable-uploads/205e1e33-ae42-4be0-ab26-0366a6368562.png",
    images: [
      "/lovable-uploads/205e1e33-ae42-4be0-ab26-0366a6368562.png",
      "/lovable-uploads/295d602f-0003-4e1e-97ea-8f6fc3a926ba.png",
      "/lovable-uploads/73eea4f9-612e-43ca-bf9a-100daf0a33da.png"
    ],
    videoUrl: "https://youtu.be/ZQ6FUxLkFTM?si=NXb_VHAUeBnZtsdj",
    slug: "dtx-1616d"
  },
  {
    id: "dtx-3232d",
    groupId: "audio-dsps",
    name: "DTX-3232D",
    description: "The DTX-3232D is a high-capacity digital signal processor designed for large-scale installations requiring extensive Dante™ audio networking capabilities. This powerful DSP offers 32×32 Dante™ digital audio channels, making it ideal for complex audio systems in larger venues, convention centers, and performance spaces.\n\nBuilt around advanced digital signal processing architecture, the DTX-3232D delivers exceptional audio quality and comprehensive processing capabilities including acoustic echo cancellation, automatic mixing, parametric equalization, dynamics processing, and sophisticated routing options. Its streamlined 1RU design maximizes rack space efficiency while providing robust connectivity options.\n\nSeamlessly integrating with ReAX control systems, the DTX-3232D can be configured via its intuitive web interface or through Aurora's control ecosystem. With dual Dante ports, USB audio, RS-232/485 control, and 8×8 GPIO integration, this DSP offers the extensive connectivity options needed for enterprise-level audio management systems.",
    features: [
      "32×32 Dante™ Digital Audio Networking",
      "48kHz, 24-bit High-Resolution Audio",
      "Acoustic Echo Cancellation (AEC)",
      "8×8 GPIO Integration",
      "ReAX Control System Compatible",
      "Browser-Based Configuration Interface",
      "Multiple Auto Mixer Modes",
      "Comprehensive EQ and Dynamics Processing",
      "Low Power Consumption (15W)",
      "1U Rack-Mountable Design",
      "RS-232 and RS-485 Control Interfaces",
      "USB Audio Interface"
    ],
    specifications: [
      "Dante I/O Channels: 32×32",
      "Frequency Response: 20Hz to 20kHz, ±0.5dB",
      "THD+N: <-94dB @17dBu",
      "Interfaces: 2 Dante Audio, 1 LAN, 1 USB Audio, RS-232, RS-485, 8×8 GPIO",
      "Power: 110-240 VAC at 50-60 Hz",
      "Power Consumption: 15W",
      "Chassis: 1U Rack Mount",
      "Input Dynamic Range: 110dB",
      "Output Dynamic Range: 112dB",
      "Analog Noise Floor: -89 dBu (A-weighted)",
      "Channel Isolation: 108 dB (1 kHz)"
    ],
    image: "/lovable-uploads/61f7efbf-fc0e-4ae7-95a7-aa155c6875fe.png",
    images: [
      "/lovable-uploads/61f7efbf-fc0e-4ae7-95a7-aa155c6875fe.png",
      "/lovable-uploads/571e1fce-d339-4c7e-870f-a108ede71af6.png",
      "/lovable-uploads/fc875996-3cd5-48c6-96f9-e82e794a243d.png"
    ],
    videoUrl: "https://youtu.be/ZQ6FUxLkFTM?si=NXb_VHAUeBnZtsdj",
    slug: "dtx-3232d"
  },
  {
    id: "dtx-6464d",
    groupId: "audio-dsps",
    name: "DTX-6464D",
    description: "The DTX-6464D is Aurora's flagship digital signal processor, featuring an impressive 64x64 Dante™ digital audio routing capability with room aggregation. This enterprise-level DSP is engineered for the most demanding installations where extensive audio management and system-wide integration is required.\n\nAs the central hub in Aurora's comprehensive audio ecosystem, the DTX-6464D is designed to connect and manage multiple rooms and audio zones through a single interface. Its powerful processing architecture enables sophisticated room combining, audio distribution, and centralized management of complex audio systems across venues, campuses, and multi-space facilities.\n\nFeaturing integration with Aurora's Dash™ Console Software, the DTX-6464D offers intuitive system configuration, monitoring, and control through a graphical user interface. Its robust connectivity options include dual redundant Dante ports, control interfaces, and GPIO integration for external device control, all in a space-efficient 1RU design perfect for installation in central equipment rooms.",
    features: [
      "64×64 Dante™ Digital Audio Networking",
      "Room Aggregation Capability",
      "Dash™ Console Software Integration",
      "48kHz, 24-bit High-Resolution Audio",
      "Comprehensive System Management",
      "8×8 GPIO Integration",
      "Dual Network Interfaces",
      "ReAX Control System Compatible",
      "Multiple Control Interfaces",
      "Audio Routing Between Zones/Rooms",
      "1U Rack-Mountable Design",
      "Low Power Consumption"
    ],
    specifications: [
      "Dante I/O Channels: 64×64",
      "Frequency Response: 20Hz to 20kHz, ±0.5dB",
      "THD+N: <-94dB @17dBu",
      "Interfaces: 2 Dante Audio, 1 LAN, RS-232, RS-485, 8×8 GPIO",
      "Power: 110-240 VAC at 50-60 Hz",
      "Power Consumption: 20W",
      "Chassis: 1U Rack Mount",
      "Dynamic Range: 110dB",
      "Control Protocols: TCP/IP, ReAX",
      "Processing: 48kHz Sample Rate, 24-bit Resolution",
      "Operating Temperature: 0°C to 40°C"
    ],
    image: "/lovable-uploads/0c23ad13-5725-452a-b4d4-5740db164a5e.png",
    images: [
      "/lovable-uploads/0c23ad13-5725-452a-b4d4-5740db164a5e.png",
      "/lovable-uploads/83f77cc5-d39c-4408-b3a6-8928eab8f964.png",
      "/lovable-uploads/95f54df5-8004-4122-9d38-8dde73784c87.png"
    ],
    videoUrl: "https://youtu.be/ZQ6FUxLkFTM?si=NXb_VHAUeBnZtsdj",
    slug: "dtx-6464d"
  },
  {
    id: "dash",
    groupId: "audio-dsps",
    name: "DASH",
    description: "DASH is Aurora Multimedia's powerful audio DSP control software, designed to provide an intuitive and comprehensive interface for managing complex audio systems. With its sleek, modern interface, DASH offers audio professionals complete control over Aurora's DSP product line, enabling seamless configuration, routing, and real-time management of sophisticated audio installations.\n\nThe DASH Console software features a highly visual approach to audio system design, with an intuitive mixer view that provides immediate access to levels, routing, and processing parameters. Engineers can quickly configure inputs and outputs, set up complex signal paths, and fine-tune audio processing with parametric EQs, dynamics processing, and automixing all from a single, unified interface.\n\nDesigned for both simplicity and depth, DASH makes complex DSP operations accessible through its graphical interface while offering the advanced tools necessary for professional audio system management. The software seamlessly integrates with Aurora's entire DSP lineup, including the DTX series processors, providing a cohesive ecosystem for audio professionals working on installations of any size.",
    features: [
      "Intuitive Graphical User Interface",
      "Real-Time DSP Control and Monitoring",
      "Comprehensive Mixer View",
      "Advanced Signal Routing Matrix",
      "Parametric EQ with Visual Feedback",
      "Dynamics Processing Controls",
      "Room Combining Functionality",
      "Multi-System Management",
      "Custom Preset Creation and Management",
      "Compatible with All DTX Series DSPs",
      "Dark Mode Interface for Control Rooms",
      "Responsive Design for Various Displays"
    ],
    specifications: [
      "Operating System: Windows 10/11",
      "Processor: Intel i5 or equivalent (minimum)",
      "RAM: 8GB (minimum), 16GB (recommended)",
      "Display Resolution: 1920 x 1080 (minimum)",
      "Network: Gigabit Ethernet",
      "Compatible Hardware: Aurora DTX Series DSPs",
      "Remote Access: Supported via VPN",
      "Multiple Device Control: Up to 32 devices simultaneously",
      "Connection: Direct LAN or across managed networks",
      "Security: Password protected system access"
    ],
    image: "/lovable-uploads/eace4698-d230-47e0-ae13-775eebdaf5bb.png",
    images: [
      "/lovable-uploads/eace4698-d230-47e0-ae13-775eebdaf5bb.png",
      "/lovable-uploads/c4dd6687-b08d-48b7-b007-3142d389830f.png",
      "/lovable-uploads/22ed7bf1-da79-47b5-b9a4-2bd52c7bd5e0.png"
    ],
    videoUrl: "https://youtu.be/ZQ6FUxLkFTM?si=NXb_VHAUeBnZtsdj",
    slug: "dash"
  }
];

export const amplifierProducts: Product[] = [
  {
    id: "dtx-amp-25-m",
    groupId: "audio-amplifiers",
    name: "DTX-AMP-25-M",
    description: "The DTX-AMP25-M is a 25-Watt PoE+ Dante/AES67 amplifier allowing audio distribution of small to very large scale. The small form factor and light weight allows it to be mounted just about anywhere. The 4/8 Ohm out can drive 2 speakers in parallel saving cost. It also features an OLED for IP Address and other status information for better setup and serviceability.\n\nEngineered for reliability and ease of installation, the DTX-AMP-25-M includes a convenient mounting bracket for discreet placement. Its 4Ω/8Ω output compatibility ensures versatility with a wide range of speaker configurations, making it the perfect solution for distributed audio systems and smaller zones in larger installations.",
    features: [
      "2x 25W Class-D Amplification (into 4Ω)",
      "2x 15W Output Power (into 8Ω)",
      "Balanced and Unbalanced Inputs",
      "Auto-Signal Sensing Power Mode",
      "4Ω/8Ω Speaker Compatibility",
      "Mounting Bracket Included",
      "Compact Form Factor",
      "Energy Efficient Design",
      "Easy Installation",
      "External DC Power Supply",
      "Over-temperature and Short-circuit Protection"
    ],
    specifications: [
      "Power Output: 2x 25W @ 4Ω, 2x 15W @ 8Ω",
      "Frequency Response: 20Hz - 20kHz ±1dB",
      "THD+N: <0.1% @ 1kHz",
      "Signal-to-Noise Ratio: >80dB",
      "Input Sensitivity: 0.775V (0dBu)",
      "Input Impedance: 10kΩ balanced, 5kΩ unbalanced",
      "Power Supply: 24VDC/2.7A external (included)",
      "Auto Standby: Activates after 15 minutes with no signal",
      "Protection: Over-temperature, short-circuit, over-current",
      "Dimensions (W x H x D): 4.25\" x 1.4\" x 3.9\" (108 x 35.5 x 99mm)",
      "Weight: 0.9 lbs (0.4 kg)",
      "Operating Temperature: 32°F to 122°F (0°C to 50°C)"
    ],
    image: "/lovable-uploads/404588bc-af93-4812-b9d6-de06cd206cf8.png",
    images: ["/lovable-uploads/404588bc-af93-4812-b9d6-de06cd206cf8.png"],
    videoUrl: "https://youtu.be/aelJzJMRWZA?si=P8NNBz8hbY9FXsVf",
    slug: "dtx-amp-25-m"
  }
];

export const speakerProducts: Product[] = [
  {
    id: "skr-22t-xfr",
    groupId: "audio-speakers",
    name: "SKR-22T-XFR",
    description: "The SKR-22T-XFR is a complete 2x2 ceiling speaker system with integrated 70/100V transformer. It delivers outstanding audio clarity for both music and voice applications in commercial environments.\n\nDesigned as a direct replacement for a standard 2'x2' ceiling tile, the SKR-22T-XFR integrates perfectly with suspended ceiling grids with no cutting or modification required. This elegant solution simplifies installation while maintaining the aesthetic integrity of the ceiling.\n\nThe SKR-22T-XFR features a multi-tap transformer allowing power adjustment to suit the specific requirements of each zone in your distributed audio system. With its wide frequency response, excellent power handling, and superior sound quality, this ceiling speaker provides an ideal solution for background music, paging, and audio reinforcement in offices, retail spaces, educational facilities, and other commercial environments.",
    features: [
      "2x2 Ceiling Tile Replacement",
      "70V/100V Compatible Multi-Tap Transformer",
      "Integrated Back Enclosure",
      "High Sound Quality Reinforcement",
      "Quick and Easy Installation",
      "Standard 2'x2' Ceiling Grid Compatible",
      "Low Profile Design",
      "Elegant White Finish",
      "Ideal for Background Music and Paging",
      "Perfect for Commercial Environments"
    ],
    specifications: [
      "Speaker Type: Full-Range",
      "Dimension: 2'x2' (600mm x 600mm)",
      "Frequency Response: 65Hz - 20kHz",
      "Transformer Taps: 30W, 15W, 7.5W, 3.75W @ 70V",
      "Coverage Pattern: 110°",
      "Sensitivity: 89dB (1W/1m)",
      "Power Handling: 30W RMS",
      "Impedance: 8Ω Direct, 70V/100V with Transformer",
      "Color: White",
      "Material: Steel Frame with Composite Speaker Grille",
      "Installation: Lay-in 2'x2' Grid Ceiling System"
    ],
    image: "/lovable-uploads/5391e8e2-c10c-40c8-b763-3fb1e0116199.png", 
    images: [
      "/lovable-uploads/8694c9c3-944c-4445-8019-023fd2c3a05c.png",  
      "/lovable-uploads/5391e8e2-c10c-40c8-b763-3fb1e0116199.png",
      "/lovable-uploads/3eb9acd8-f1c7-4fd8-9c86-ce75f8317ea2.png"
    ],
    slug: "skr-22t-xfr"
  }
];

export const audioProducts: Product[] = [
  ...dspProducts,
  ...amplifierProducts,
  ...speakerProducts
];
